/**
 * @generated SignedSource<<5fb727113e78c7fccbc6a4755cd88b6c>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { Fragment, ReaderFragment } from 'relay-runtime';
export type MatchOp = "EQUAL" | "CONTAINS" | "%future added value";
export type VisitMatch = "EQUAL_MATCH_TYPE" | "OVER_MATCH_TYPE" | "UNDER_MATCH_TYPE" | "%future added value";
import { FragmentRefs } from "relay-runtime";
export type ChatbotDistributionSettingSection_chatbotGroup$data = {
  readonly sources: ReadonlyArray<{
    readonly id: string;
    readonly name: string;
  }>;
  readonly referrers: ReadonlyArray<{
    readonly referrer: string;
    readonly matchOp: MatchOp;
  }>;
  readonly excludeReferrers: ReadonlyArray<{
    readonly referrer: string;
    readonly matchOp: MatchOp;
  }>;
  readonly visitCount: number | null;
  readonly visitMatchType: VisitMatch;
  readonly deliverTargetUrls: ReadonlyArray<{
    readonly id: string;
    readonly url: string;
  }>;
  readonly deliverExcludeUrls: ReadonlyArray<{
    readonly id: string;
    readonly url: string;
  }>;
  readonly targetCookies: ReadonlyArray<{
    readonly id: string;
    readonly key: string;
    readonly value: string;
    readonly matchType: boolean;
  }>;
  readonly " $fragmentType": "ChatbotDistributionSettingSection_chatbotGroup";
};
export type ChatbotDistributionSettingSection_chatbotGroup = ChatbotDistributionSettingSection_chatbotGroup$data;
export type ChatbotDistributionSettingSection_chatbotGroup$key = {
  readonly " $data"?: ChatbotDistributionSettingSection_chatbotGroup$data;
  readonly " $fragmentSpreads": FragmentRefs<"ChatbotDistributionSettingSection_chatbotGroup">;
};

const node: ReaderFragment = (function(){
var v0 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "id",
  "storageKey": null
},
v1 = [
  {
    "alias": null,
    "args": null,
    "kind": "ScalarField",
    "name": "referrer",
    "storageKey": null
  },
  {
    "alias": null,
    "args": null,
    "kind": "ScalarField",
    "name": "matchOp",
    "storageKey": null
  }
],
v2 = [
  (v0/*: any*/),
  {
    "alias": null,
    "args": null,
    "kind": "ScalarField",
    "name": "url",
    "storageKey": null
  }
];
return {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "ChatbotDistributionSettingSection_chatbotGroup",
  "selections": [
    {
      "alias": null,
      "args": null,
      "concreteType": "Source",
      "kind": "LinkedField",
      "name": "sources",
      "plural": true,
      "selections": [
        (v0/*: any*/),
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "name",
          "storageKey": null
        }
      ],
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "concreteType": "ChatbotGroupReferrer",
      "kind": "LinkedField",
      "name": "referrers",
      "plural": true,
      "selections": (v1/*: any*/),
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "concreteType": "ChatbotGroupExcludeReferrer",
      "kind": "LinkedField",
      "name": "excludeReferrers",
      "plural": true,
      "selections": (v1/*: any*/),
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "visitCount",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "visitMatchType",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "concreteType": "ChatbotGroupDeliverTargetUrl",
      "kind": "LinkedField",
      "name": "deliverTargetUrls",
      "plural": true,
      "selections": (v2/*: any*/),
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "concreteType": "ChatbotGroupDeliverExcludeUrl",
      "kind": "LinkedField",
      "name": "deliverExcludeUrls",
      "plural": true,
      "selections": (v2/*: any*/),
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "concreteType": "ChatbotGroupTargetCookie",
      "kind": "LinkedField",
      "name": "targetCookies",
      "plural": true,
      "selections": [
        (v0/*: any*/),
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "key",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "value",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "matchType",
          "storageKey": null
        }
      ],
      "storageKey": null
    }
  ],
  "type": "ChatbotGroup",
  "abstractKey": null
};
})();

(node as any).hash = "0b081a1ceda8ae48c764aba4fa13fb83";

export default node;
